import React, { useState, useEffect } from "react";
import "./CommercialRules.css";
import axios from "axios";
import Swal from "sweetalert2";
import { FaSpinner } from "react-icons/fa6";
import { Modal, Spinner } from "react-bootstrap";



export default function TradeRules() {
  const [clients, setClients] = useState([]);
  const [excCharges, setExcCharges] = useState([]);
  const [excTypes, setExcTypes] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  const [selectedClient, setSelectedClient] = useState("");
  const [copyToClient, setCopyToClient] = useState("");
  const [rules, setRules] = useState([]);

  const [loadingRules, setLoadingRules] = useState(false);
  const [saving, setSaving] = useState(false);

  /* =======================
     CARGA INICIAL
  ======================= */
  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/rules`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      if (response.data.code === 1) {
        setClients(response.data.data.clients);
        setExcCharges(response.data.data.excCharges);
        setExcTypes(response.data.data.excTypes);
        setCurrencies(response.data.data.currencies);
      }
    } catch {
      Swal.fire("Error", "Hubo un error al obtener los datos", "error");
    }
  };

  /* =======================
     CAMBIO DE CLIENTE
  ======================= */
  const handleClientChange = async (e) => {
    const clientId = e.target.value;

    setSelectedClient(clientId);
    setRules([]);
    setCopyToClient("");

    if (!clientId) return;

    setLoadingRules(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/rules/getRules`,
        { client_id: clientId },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      const exceptions = response.data.data.exceptions || [];

      const newRules = excCharges.map((c) => {
        const found = exceptions.find(
          (ex) => Number(ex.exception_charge_id) === Number(c.id)
        );

        return {
          id: c.id,
          concepto: c.name,
          excepcion: Boolean(found),
          tipoExcepcion: found ? found.exception_type_id : "",
          cantidad: found ? String(found.value) : "",
          moneda: found ? found.currency_id : "",
          congelacion: found ? (Number(found.is_third_party) === 1) : false,
        };
      });

      setRules(newRules);
    } catch {
      Swal.fire("Error", "Hubo un error al obtener las reglas", "error");
    } finally {
      setLoadingRules(false);
    }
  };

  const updateRule = (index, field, value) => {
    if (field === "cantidad") {
      const regex = /^[0-9]*[.,]?[0-9]*$/;

      if (!regex.test(value)) {
        return;
      }
    }

    setRules((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  /* =======================
     GUARDAR / COPIAR
  ======================= */
/* =======================
     GUARDAR / COPIAR
  ======================= */
  const saveRules = async (type) => {
    if (saving) return;

    if (!selectedClient) return;

    // --- INICIO DE VALIDACIÓN ---
    // Recorremos todas las reglas para ver si hay alguna incompleta
    for (const rule of rules) {
      // Si el check está activado...
      if (rule.excepcion) {
        // ... verificamos que los campos obligatorios tengan valor
        if (!rule.tipoExcepcion || !rule.cantidad || !rule.moneda) {
          Swal.fire(
            "Campos incompletos",
            `Para activar la excepción en "<strong>${rule.concepto}</strong>", debes llenar Tipo, Cantidad y Moneda.`,
            "warning"
          );
          return; // Detenemos la función aquí, no se guarda nada.
        }
      }
    }
    // --- FIN DE VALIDACIÓN ---

    let client_id = "";
    if (type === "save") {
      client_id = selectedClient;
    } else if (type === "copy") {
      client_id = copyToClient;
    }

    if (!client_id) return;

    setSaving(true);

    const body = { client_id };

    rules.forEach((r) => {
      if (r.excepcion) {
        body[`charge_${r.id}`] = "on";
        body[`type_${r.id}`] = r.tipoExcepcion;
        body[`value_${r.id}`] = Number(r.cantidad);
        body[`currency_${r.id}`] = r.moneda;

        // 👇 AQUÍ SE MANDA third_party
        if (r.concepto === "Congelación" && r.congelacion) {
          body["third_party"] = "1";
        }
      }
    });

    try {
      await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/rules/saveRules`,
        body,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      Swal.fire("Guardado", "Reglas guardadas correctamente", "success");
    } catch {
      Swal.fire("Error", "Error al guardar reglas", "error");
    } finally {
      setSaving(false);
    }
  };


  return (
    <div className="rules-container">
      {/* HEADER */}
      <div className="rules-header">
        <h2>Reglas comerciales</h2>

        <div className="header-inputs-row">
          {/* CLIENTE */}
          <div className="field header-field">
            <label>Cliente</label>
            <select
              value={selectedClient}
              disabled={loadingRules || saving}
              onChange={handleClientChange}
            >
              <option value="">Selecciona un cliente</option>
              {clients.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>

          {/* COPIAR A */}
          <div className="field header-field">
            <label>Copiar reglas a</label>
            <select
              value={copyToClient}
              disabled={loadingRules || saving}
              onChange={(e) => setCopyToClient(e.target.value)}
            >
              <option value="">Selecciona un cliente</option>
              {clients.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>

          {/* CAMBIO AQUÍ: Desaparece botón, aparece Loader */}
          <div className="header-field">
            <label style={{ visibility: "hidden" }}>Acción</label>{" "}
            {/* Para alinear con los selects */}
            {saving ? (
              <div className="action-btn-container">
                {!saving ? (
                  <button
                    className="btn-copy"
                    disabled={!copyToClient || copyToClient === ""}
                    onClick={() => saveRules("copy")}
                  >
                    Copiar reglas
                  </button>
                ) : (
                  <FaSpinner className="loader-spiner-filter" />
                )}
              </div>
            ) : (
              <button
                className="btn-copy"
                disabled={!copyToClient}
                onClick={() => saveRules("copy")}
              >
                Copiar reglas
              </button>
            )}
          </div>
        </div>
      </div>

      {/* TABLA */}
      {selectedClient && (
        <div className="table-wrapper">
          {loadingRules ? (
            <div className="table-loader">
              <FaSpinner className="loader-spiner-filter" />
              <span>Cargando reglas...</span>
            </div>
          ) : (
            <table className="rules-table">
              <thead>
                <tr>
                  <th>Concepto</th>
                  <th style={{ textAlign: "center" }}>Excepción</th>
                  <th>Tipo excepción</th>
                  <th>Cantidad</th>
                  <th>Moneda</th>
                </tr>
              </thead>

              <tbody>
                {rules.map((item, i) => (
                  <tr key={item.id}>
                    <td>{item.concepto}</td>

                    <td style={{ textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={item.excepcion}
                        onChange={(e) =>
                          updateRule(i, "excepcion", e.target.checked)
                        }
                      />
                    </td>

                    <td>
                      <select
                        value={item.tipoExcepcion}
                        disabled={!item.excepcion}
                        onChange={(e) => {
                          const nuevoTipoId = e.target.value;
                          const tipoSeleccionado = excTypes.find(t => String(t.id) === String(nuevoTipoId));
                          const nombreTipo = tipoSeleccionado ? tipoSeleccionado.name.toLowerCase() : "";
                          
                          let cantidadActual = item.cantidad;

                          // Si cambia a porcentaje y la cantidad actual es > 100, la bajamos a 100
                          if ((nombreTipo.includes("porcentaje") || nombreTipo.includes("%")) && parseFloat(cantidadActual) > 100) {
                            updateRule(i, "cantidad", "100");
                          }

                          updateRule(i, "tipoExcepcion", nuevoTipoId);
                        }}
                      >
                        <option value="" disabled hidden></option>
                        {excTypes.map((t) => (
                          <option key={t.id} value={t.id}>
                            {t.name}
                          </option>
                        ))}
                      </select>
                    </td>

                    <td>
                      <input
                        type="text"
                        className="cantidad-input"
                        value={item.cantidad}
                        disabled={!item.excepcion}
                        inputMode="decimal" // Optimiza el teclado en móvile
                        onChange={(e) => {
                          // 1. Limpieza inicial: Convertir coma a punto y dejar solo números y un punto
                          let val = e.target.value.replace(",", ".").replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1");

                          // 2. Identificar si el tipo seleccionado es "Porcentaje"
                          // Buscamos en el array excTypes el objeto que coincida con el ID seleccionado actualmente
                          const tipoSeleccionado = excTypes.find(t => String(t.id) === String(item.tipoExcepcion));
                          const nombreTipo = tipoSeleccionado ? tipoSeleccionado.name.toLowerCase() : "";

                          // 3. Aplicar regla del 100
                          if (nombreTipo.includes("porcentaje") || nombreTipo.includes("%")) {
                            if (val.startsWith("0")) {
                              val = val.replace(/^0+/, "");
                            }
                            
                            const numVal = parseFloat(val);
                            if (!isNaN(numVal) && numVal > 100) {
                              val = "100";
                            }
                          }

                          // 4. Actualizar el estado con el valor final
                          updateRule(i, "cantidad", val);
                        }}
                      />
                    </td>

                    <td>
                      <div className="moneda-container">
                        <select
                          className="moneda-select"
                          value={item.moneda}
                          disabled={!item.excepcion}
                          onChange={(e) =>
                            updateRule(i, "moneda", e.target.value)
                          }
                        >
                          <option value="" disabled hidden></option>
                          {currencies.map((m) => (
                            <option key={m.id} value={m.id}>
                              {m.name}
                            </option>
                          ))}
                        </select>

                        {item.concepto === "Congelación" && (
                          <label className="precio-terceros" htmlFor={`is_third_party_${item.id}`}>
                            ¿Precio terceros?
                            <input
                              type="checkbox"
                              id={`is_third_party_${item.id}`}
                              name="third_party"
                              value="1"
                              checked={!!item.congelacion}
                              disabled={!item.excepcion}
                              onChange={(e) =>
                                updateRule(i, "congelacion", e.target.checked)
                              }

                            />
                          </label>

                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          <Modal
            show={saving}
            onHide={() => {}} // No hacemos nada al cerrar para que sea obligatorio esperar
            backdrop="static"
            keyboard={false}
            centered
            dialogClassName="custom-modal"
            backdropClassName="custom-backdrop"
          >
            <div className="spinner-container">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Cargando...</span>
              </Spinner>
            </div>
          </Modal>
          <div
            className="save-wrapper"
            style={{
              minHeight: "50px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="action-btn-container">
                <button
                  className="btn-save"
                  onClick={() => saveRules("save")}
                >
                  Guardar
                </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
